import React from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${props => props.theme.colors.background};

  @media print {
    display: block !important;
    background-color: white !important;
  }
`;

const MainContent = styled.div`
  flex: 1;
  margin-left: 250px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin-left: 200px;
  }

  @media print {
    margin-left: 0 !important;
    display: block !important;
  }
`;

const ContentArea = styled.main`
  flex: 1;
  padding: ${props => props.theme.spacing.xl};
  overflow-y: auto;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    padding: ${props => props.theme.spacing.lg};
  }

  @media print {
    padding: 0 !important;
    overflow: visible !important;
  }
`;

const SidebarWrapper = styled.div`
  @media print {
    display: none !important;
  }
`;

const HeaderWrapper = styled.div`
  @media print {
    display: none !important;
  }
`;

const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <SidebarWrapper>
        <Sidebar />
      </SidebarWrapper>
      <MainContent>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
